import React, { useEffect, useState } from "react";
import { SMARTCAPTCHA_SITE_KEY } from "../../../core/consts/redesign/commonRedesign";
import authService from "../../../core/services/AuthService";

declare global {
  interface Window {
    smartCaptcha: {
      render: (
        container: HTMLElement | string,
        params: {
          sitekey: string;
          callback?: (token: string) => void;
          hl?: "ru" | "en" | "be" | "kk" | "tt" | "uk" | "uz" | "tr";
          test?: boolean;
          webview?: boolean;
          invisible?: boolean;
          shieldPosition?:
            | `top-left`
            | `center-left`
            | `bottom-left`
            | `top-right`
            | `center-right`
            | `bottom-right`;
          hideShield?: boolean;
        }
      ) => string;
      getResponse: (widgetId: string) => string | null;
    };
  }
}

interface CaptchaProps {
  onVerify: (isVerified: boolean) => void;
  containerClassName?: string;
}

export const Captcha: React.FC<CaptchaProps> = ({
  onVerify,
  containerClassName,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [widgetId, setWidgetId] = useState<string | null>(null);
  const [captchaError, setCaptchaError] = useState<string | null>(null);

  useEffect(() => {
    const onloadFunction = () => {
      const id = window.smartCaptcha.render("captcha-container", {
        sitekey: SMARTCAPTCHA_SITE_KEY,
        hl: "ru",
        callback: handleCaptchaCallback,
      });
      setWidgetId(id);
    };
    (window as any).onloadFunction = onloadFunction;

    const script = document.createElement("script");
    script.src =
      "https://smartcaptcha.yandexcloud.net/captcha.js?render=onload&onload=onloadFunction";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCaptchaCallback = async (captchaToken: string) => {
    try {
      const isValid = await authService.validateCaptcha(
        captchaToken,
        undefined
      );
      onVerify(isValid);
      if (!isValid) {
        setCaptchaError(
          "Ошибка капчи - попробуйте обновить страницу и повторить попытку"
        );
      } else {
        setCaptchaError(null);
      }
    } catch (error) {
      console.error("Error validating captcha:", error);
      setCaptchaError(
        "Ошибка капчи - попробуйте обновить страницу и повторить попытку"
      );
      onVerify(false);
    }
  };

  return (
    <div className={containerClassName}>
      <div
        id="captcha-container"
        className="smart-captcha"
        data-sitekey={SMARTCAPTCHA_SITE_KEY}
      />
      {captchaError && <div className="error">{captchaError}</div>}
    </div>
  );
};
